import { Link } from 'react-router-dom';
import CategoryDropdown from './CategoryDropdown';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20aerial%20view%20of%20a%20modern%20fashion%20district%20at%20dusk%20with%20neon%20storefront%20signs%20reflecting%20on%20wet%20cobblestone%20streets%2C%20silhouettes%20of%20shoppers%20carrying%20bags%2C%20bicycle%20racks%20and%20outdoor%20cafe%20tables%2C%20urban%20nightlife%20energy%20with%20warm%20amber%20and%20cool%20teal%20light%20accents%2C%20cinematic%20cityscape%20editorial%20photography&width=1600&height=900&seq=hero-bg-v2&orientation=landscape"
        alt="Hipobuy Spreadsheet product research background"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-8 py-20 md:py-0">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
                Hipobuy<br />
                Spreadsheet<br />
                <span className="text-primary-300">2026</span>
              </h1>
              <p className="text-base md:text-lg text-background-200 font-body max-w-lg leading-relaxed mb-8">
                Discover the latest Hipobuy Spreadsheet resources, product categories, comparison guides and safety tips. Find better products faster with organized spreadsheet research.
              </p>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 flex-wrap">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold font-label hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Explore Hipobuy Sheet
                  <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
                </a>
                <Link
                  to="/hipobuy-spreadsheet-beginner"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-semibold font-label hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Start Beginner Guide
                  <i className="ri-book-open-line text-sm w-4 h-4 flex items-center justify-center"></i>
                </Link>
                <CategoryDropdown />
              </div>

              <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-8">
                <span className="inline-flex items-center gap-1.5 text-xs text-background-200 font-label">
                  <i className="ri-check-line text-primary-300 text-sm w-4 h-4 flex items-center justify-center"></i>
                  Updated 2026 Resources
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs text-background-200 font-label">
                  <i className="ri-check-line text-primary-300 text-sm w-4 h-4 flex items-center justify-center"></i>
                  Beginner Friendly Guides
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs text-background-200 font-label">
                  <i className="ri-check-line text-primary-300 text-sm w-4 h-4 flex items-center justify-center"></i>
                  Detailed Comparison Tables
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs text-background-200 font-label">
                  <i className="ri-check-line text-primary-300 text-sm w-4 h-4 flex items-center justify-center"></i>
                  Safety Education
                </span>
              </div>
            </div>

            <div className="hidden lg:flex flex-col gap-4">
              <div className="bg-background-50/10 backdrop-blur-sm rounded-2xl p-6 border border-background-50/15">
                <h3 className="text-background-50 font-heading text-xl font-semibold mb-3">Quick Category Access</h3>
                <div className="grid grid-cols-2 gap-2">
                  {[
                    { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
                    { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
                    { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
                    { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
                    { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
                    { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
                    { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
                    { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
                  ].map((item) => (
                    <a
                      key={item.name}
                      href={item.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-xs text-background-200 hover:text-background-50 py-1.5 px-3 rounded-lg hover:bg-background-50/10 transition-colors font-body truncate cursor-pointer"
                    >
                      {item.name}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a href="#intro" className="flex flex-col items-center gap-2 text-background-200 hover:text-background-50 transition-colors cursor-pointer">
          <span className="text-xs font-label">Scroll to explore</span>
          <i className="ri-arrow-down-line text-lg animate-bounce w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}